var map = {
	"./access-credentials.svg": "1416",
	"./ai.svg": "23d0",
	"./alert-event.svg": "1672",
	"./alipay.svg": "1b1d",
	"./aliyun.svg": "1f36",
	"./amd.svg": "3a5b",
	"./app_store.svg": "a078",
	"./apsara.svg": "77c3",
	"./arrow-right.svg": "206b",
	"./auth/password.svg": "4aba",
	"./auth/safety-certificate.svg": "2c33",
	"./auth/user-delete.svg": "1e6a",
	"./auth/user.svg": "345f",
	"./auto-set.svg": "5b62",
	"./aws.svg": "9f4f",
	"./azure.svg": "736c",
	"./baidu.svg": "acdd",
	"./bank-card.svg": "beca",
	"./bigger.svg": "829c",
	"./bill-resource.svg": "dc11",
	"./bill-set-cny.svg": "fe0d",
	"./bill-set-usd.svg": "6caf",
	"./bingocloud.svg": "f5d3",
	"./blank.svg": "f339",
	"./cancel.svg": "687b",
	"./caret-down.svg": "eebf",
	"./cas.svg": "cbf1",
	"./ceph.svg": "93dc",
	"./cephfs.svg": "2d1f",
	"./change-password.svg": "2a4a",
	"./checkbox-empty.svg": "a11e",
	"./checkbox-fill.svg": "5676",
	"./checkbox-some.svg": "4dc9",
	"./chinaunion.svg": "3a53",
	"./chrome.svg": "f4f8",
	"./close.svg": "86c2",
	"./cloud.svg": "3613",
	"./cloudflare.svg": "fe62",
	"./cloudpods.svg": "57c9",
	"./cloudshell.svg": "46a62",
	"./cnware.svg": "81e94",
	"./code.svg": "8e1d",
	"./copy.svg": "e67b",
	"./coupon.svg": "c55b",
	"./cpu.svg": "41ec",
	"./ctyun.svg": "63af",
	"./daping.svg": "07a7",
	"./dashboard-alert-sum.svg": "b994",
	"./dashboard-alerts-trend.svg": "9afa",
	"./dashboard-bar.svg": "3da5",
	"./dashboard-bill-number.svg": "9d44",
	"./dashboard-bill-pie.svg": "cc87",
	"./dashboard-bill-stack.svg": "df0f",
	"./dashboard-cloud-account-health.svg": "7ec6",
	"./dashboard-consmption-trend.svg": "381d",
	"./dashboard-consumption-percent.svg": "8098",
	"./dashboard-fee.svg": "2884",
	"./dashboard-log.svg": "efa9",
	"./dashboard-notice.svg": "68c2",
	"./dashboard-number.svg": "e1d5",
	"./dashboard-quota.svg": "cdaf",
	"./dashboard-resource-count.svg": "9134",
	"./dashboard-resource.svg": "f36e",
	"./dashboard-search.svg": "6d98",
	"./dashboard-server-number.svg": "bd40",
	"./dashboard-suggest-detail.svg": "91a6",
	"./dashboard-suggest-overview.svg": "7f87",
	"./dashboard-title.svg": "a130",
	"./dashboard-top5.svg": "4df3",
	"./dashboard-trend.svg": "1e51",
	"./dashboard-usage.svg": "ad72",
	"./dashboard-user-info.svg": "719a",
	"./dashboard-vmhistory-count-trend.svg": "8228",
	"./data-empty.svg": "2c79",
	"./delete.svg": "6279",
	"./dimension.svg": "2fb4",
	"./dingtalk.svg": "f7f2",
	"./dollar.svg": "89ea",
	"./download.svg": "d9ae",
	"./drag.svg": "c42d",
	"./draggable.svg": "e387",
	"./dstack.svg": "7bb2",
	"./ecloud.svg": "0690",
	"./email.svg": "3310",
	"./excel.svg": "741a",
	"./expand.svg": "b595",
	"./extdb.svg": "13c8",
	"./feishu.svg": "3b7d",
	"./gaokeyong.svg": "ff948",
	"./gold.svg": "96ff",
	"./google.svg": "866d",
	"./gpu.svg": "8499",
	"./h3c.svg": "44d4",
	"./hcs.svg": "ba86",
	"./hcso.svg": "fd36",
	"./hcsop.svg": "0c0d",
	"./help.svg": "8f85",
	"./hp.svg": "d652",
	"./huawei.svg": "66f8",
	"./icon_add.svg": "0773",
	"./icon_after_shutdown.svg": "9f1e",
	"./icon_ascent.svg": "977a",
	"./icon_baremetal.svg": "e455",
	"./icon_cloudsell.svg": "ffab",
	"./icon_cpu.svg": "fe68",
	"./icon_decline.svg": "bdd2",
	"./icon_dropdown.svg": "234c",
	"./icon_menu.svg": "55a1",
	"./icon_monitor.svg": "4c1c",
	"./icon_monitor_vnc.svg": "87d1",
	"./icon_more.svg": "3c5e",
	"./icon_next.svg": "dbf11",
	"./icon_notice.svg": "fd9a",
	"./icon_off.svg": "3026",
	"./icon_open.svg": "7d4e",
	"./icon_optimization.svg": "4430",
	"./icon_ram.svg": "e3de",
	"./icon_reboot.svg": "248c3",
	"./icon_remote.svg": "369d",
	"./icon_running.svg": "6ef0",
	"./icon_search.svg": "9c1f",
	"./icon_shuttingdown.svg": "0d3d",
	"./icon_stop.svg": "b84f",
	"./icon_tenant.svg": "0a7b",
	"./icon_vnc.svg": "9f02",
	"./incloudsphere.svg": "2bb8",
	"./info.svg": "f534",
	"./info2.svg": "6781",
	"./insert.svg": "0338",
	"./integral.svg": "9eb6",
	"./jdcloud.svg": "3d06",
	"./k8s.svg": "b013",
	"./keypairs.svg": "d8ed",
	"./kongzhitai.svg": "3174",
	"./ksyun.svg": "3664",
	"./language.svg": "b59c",
	"./large-page-memory.svg": "aa09",
	"./loading.svg": "96ab",
	"./logo.svg": "bec4",
	"./menu-ai.svg": "c74f",
	"./menu-compute.svg": "cabb",
	"./menu-dashboard.svg": "81fd",
	"./menu-db.svg": "c8c3",
	"./menu-extdb.svg": "34b4",
	"./menu-game.svg": "71c3",
	"./menu-helm.svg": "f2e0",
	"./menu-iam.svg": "76da",
	"./menu-k8s.svg": "bb41a",
	"./menu-meter.svg": "a4bc",
	"./menu-middleware.svg": "266a",
	"./menu-monitor.svg": "7a75",
	"./menu-multicloud.svg": "9551",
	"./menu-network.svg": "b00b",
	"./menu-operation.svg": "900d",
	"./menu-products.svg": "3e21",
	"./menu-report.svg": "80d8",
	"./menu-setting.svg": "4b44",
	"./menu-star.svg": "bf14",
	"./menu-storage.svg": "f99e",
	"./menu-suggest.svg": "c9cb",
	"./menu-tenant.svg": "0d4c",
	"./menu.svg": "0788",
	"./minimize.svg": "5995",
	"./mobile.svg": "4d68",
	"./mongodb.svg": "d53b",
	"./monitor-operation.svg": "aef7",
	"./more.svg": "13f3",
	"./move.svg": "fc15",
	"./navbar-more.svg": "d3bb",
	"./navbar-notify.svg": "a114",
	"./navbar-process.svg": "2940",
	"./navbar-project.svg": "5a18",
	"./navbar-setting.svg": "81ae",
	"./navbar-user.svg": "4139",
	"./navbar-view-switch.svg": "dcd8",
	"./nutanix.svg": "040b",
	"./nvidia.svg": "c484",
	"./oceanbase.svg": "5b60",
	"./onecloud-map.svg": "4bb1",
	"./onecloud.svg": "8afd",
	"./open.svg": "8efb",
	"./openshift.svg": "5159",
	"./openstack.svg": "36c2",
	"./oraclecloud.svg": "09d1",
	"./organization.svg": "55fc9",
	"./passthrough.svg": "93f7",
	"./password.svg": "c6ec",
	"./pdf.svg": "a707",
	"./pin.svg": "8692",
	"./projectmapping.svg": "446f",
	"./proxmox.svg": "4859",
	"./pull-down.svg": "d9b9",
	"./qcloud.svg": "f284",
	"./qianwen.svg": "47a3",
	"./qingcloud.svg": "da39",
	"./question.svg": "6af32",
	"./refresh.svg": "1529",
	"./remotefile.svg": "e6c3",
	"./res-access-group.svg": "2d78",
	"./res-agent-llm-image.svg": "e496",
	"./res-ai-gateway.svg": "cf5f",
	"./res-ai-provider.svg": "6499",
	"./res-ai-proxy-node.svg": "846f",
	"./res-ai-routing.svg": "122d",
	"./res-ai-virtual-key.svg": "c5f7",
	"./res-alert-setting.svg": "891b",
	"./res-alert.svg": "66bd",
	"./res-alertrecord.svg": "b578",
	"./res-alertresource.svg": "70ca",
	"./res-app-desktop-image.svg": "2d4af",
	"./res-app-desktop-sku.svg": "6915",
	"./res-app-desktop.svg": "75b4",
	"./res-app-llm-sku.svg": "89b2",
	"./res-app-llm.svg": "ed00",
	"./res-backup-storage.svg": "9174",
	"./res-baremetal.svg": "394f",
	"./res-bastion-host.svg": "6dfd",
	"./res-bill-alarm.svg": "f24f",
	"./res-bill-config.svg": "be51",
	"./res-bill-dailydetail.svg": "5913",
	"./res-bill-monthlydetail.svg": "7e4c",
	"./res-bill-product.svg": "83ee",
	"./res-billaccount.svg": "840c",
	"./res-billanalysis-alarm.svg": "4d2d",
	"./res-billanalysis-report.svg": "c456",
	"./res-billanalysis.svg": "352a",
	"./res-billdomain.svg": "025d",
	"./res-billexchangerate.svg": "1235",
	"./res-billexternalproject.svg": "773c",
	"./res-billoriginresourcetype.svg": "2d17",
	"./res-billoverview.svg": "92fe",
	"./res-billproducttype.svg": "2106",
	"./res-billproject.svg": "5a35",
	"./res-billrate.svg": "b464",
	"./res-billresourcetype.svg": "6b86",
	"./res-billstatistic.svg": "d6de",
	"./res-billsummary.svg": "614c",
	"./res-billtag.svg": "32bd",
	"./res-billtask.svg": "65ff",
	"./res-billtime.svg": "bd6c",
	"./res-blockstorage.svg": "9556",
	"./res-brand.svg": "d39d",
	"./res-broadcast.svg": "b295",
	"./res-bucket.svg": "7a611",
	"./res-budget.svg": "f92d",
	"./res-cdn-domain.svg": "116a",
	"./res-cdn.svg": "b65a",
	"./res-children-task.svg": "7565",
	"./res-cloudaccount.svg": "186a",
	"./res-cloudevent.svg": "ea99",
	"./res-cloudgroup.svg": "fb37",
	"./res-cloudregion.svg": "64e1",
	"./res-cluster.svg": "50f8",
	"./res-command-log.svg": "230e",
	"./res-commonalert.svg": "f23c",
	"./res-commonalerts.svg": "5474",
	"./res-companyinfo.svg": "94ea",
	"./res-contact.svg": "19db",
	"./res-custom-data.svg": "d73d",
	"./res-daily-report-subscription.svg": "58b9",
	"./res-dashboard.svg": "3be8",
	"./res-dictionarysetting.svg": "f020",
	"./res-disk-backup.svg": "ff0d",
	"./res-disk-snapshot.svg": "dbbe",
	"./res-disk.svg": "311e",
	"./res-diskrecovery.svg": "b258",
	"./res-dns-zone.svg": "7c8f",
	"./res-dns.svg": "235c",
	"./res-domain.svg": "01ee",
	"./res-dynamicschedtag.svg": "31f0",
	"./res-eip.svg": "c677",
	"./res-elasticsearch.svg": "69b1",
	"./res-endpoint.svg": "0e2b",
	"./res-explorer.svg": "c35f",
	"./res-file-system.svg": "85c6",
	"./res-flexnetwork.svg": "95a4",
	"./res-globalsetting.svg": "74b9",
	"./res-globalvpc.svg": "bc96",
	"./res-gpu.svg": "59b5",
	"./res-group.svg": "9b52",
	"./res-health-check.svg": "6349",
	"./res-host.svg": "016c",
	"./res-host_image.svg": "e9b3",
	"./res-iamsecurityalerts.svg": "c138",
	"./res-iamsuggestsysalert.svg": "9b12",
	"./res-iamsuggestsysrule.svg": "5b82",
	"./res-iamsuggestsysruleconfig.svg": "e19c",
	"./res-identity-provider.svg": "7c68",
	"./res-idp.svg": "ba7f",
	"./res-image.svg": "0d6e",
	"./res-imagerecovery.svg": "0ff7",
	"./res-inspection.svg": "807d",
	"./res-instance-backup.svg": "2ab8",
	"./res-instance-snapshot.svg": "4626",
	"./res-instancegroup.svg": "a72e",
	"./res-ip.svg": "acda",
	"./res-ipset.svg": "66b8",
	"./res-ipv6-gateway.svg": "e8db",
	"./res-k8s-chart.svg": "1b98",
	"./res-k8s-cluster.svg": "6e78",
	"./res-k8s-configmap.svg": "6fcc",
	"./res-k8s-cronjob.svg": "1e3a",
	"./res-k8s-daemonset.svg": "1ddb4",
	"./res-k8s-deployment.svg": "e54e",
	"./res-k8s-federatedclusterrole.svg": "697e1",
	"./res-k8s-federatedclusterrolebinding.svg": "48f4",
	"./res-k8s-federatednamespace.svg": "672c",
	"./res-k8s-federatedrole.svg": "591d",
	"./res-k8s-federatedrolebinding.svg": "f46b",
	"./res-k8s-ingress.svg": "d102",
	"./res-k8s-job.svg": "21455",
	"./res-k8s-kubecluster.svg": "242b",
	"./res-k8s-kubecomponent.svg": "27a1",
	"./res-k8s-namespace.svg": "74f5",
	"./res-k8s-node.svg": "4cc9",
	"./res-k8s-persistentvolumeclaim.svg": "5e41",
	"./res-k8s-pod.svg": "b6e9",
	"./res-k8s-rbacclusterrole.svg": "f720",
	"./res-k8s-rbacclusterrolebinding.svg": "7dec",
	"./res-k8s-rbacrole.svg": "c59d",
	"./res-k8s-rbacrolebinding.svg": "7f3c",
	"./res-k8s-release.svg": "6850",
	"./res-k8s-repo.svg": "a1d9",
	"./res-k8s-repos.svg": "3e98",
	"./res-k8s-secret.svg": "08de",
	"./res-k8s-service.svg": "b32a",
	"./res-k8s-serviceaccount.svg": "e88e4",
	"./res-k8s-statefulset.svg": "05962",
	"./res-k8s-storageclass.svg": "e7b2",
	"./res-kafka.svg": "eab0",
	"./res-keypair.svg": "b70d",
	"./res-kuaizhao.svg": "7906",
	"./res-kuaizhaocelue.svg": "f631",
	"./res-lb.svg": "a631",
	"./res-lbacl.svg": "e226",
	"./res-lbagent.svg": "ed60",
	"./res-lbbackendgroup.svg": "f32b",
	"./res-lbcert.svg": "72e3",
	"./res-lblistener.svg": "e9f8",
	"./res-lblistenerrule.svg": "80d3",
	"./res-llm-benchmark.svg": "19d3",
	"./res-llm-deployment.svg": "ddf0",
	"./res-llm-image.svg": "edaa",
	"./res-llm-instantmodel.svg": "8b6d",
	"./res-llm-sku.svg": "efb9",
	"./res-llm.svg": "655cf",
	"./res-log-manage.svg": "ec9d",
	"./res-log.svg": "73bd",
	"./res-mcp.svg": "d990",
	"./res-modelarts.svg": "e355",
	"./res-mongodb.svg": "bc5d",
	"./res-monitor-dashboard.svg": "d531",
	"./res-monitoroverview.svg": "e80b",
	"./res-monitorresourcealerts.svg": "d698",
	"./res-monitorresources-guest.svg": "8884",
	"./res-monitorresources-host.svg": "28e9",
	"./res-month-report-subscription.svg": "86ca",
	"./res-month.svg": "a840",
	"./res-mount-target.svg": "e25e",
	"./res-nas.svg": "1dd6",
	"./res-nat.svg": "70ef",
	"./res-network.svg": "9ea6",
	"./res-networkinterfaces.svg": "82e6",
	"./res-notice.svg": "ed52",
	"./res-notification.svg": "f9cef",
	"./res-notify-topic.svg": "1100b",
	"./res-notifyconfig.svg": "5f8c",
	"./res-offline-export.svg": "8d23",
	"./res-organization.svg": "c7e5",
	"./res-physicalmachine.svg": "cc66",
	"./res-policy.svg": "96381",
	"./res-policydefinition.svg": "cf57",
	"./res-pricecomparator.svg": "14ec",
	"./res-processmanage.svg": "7653",
	"./res-project-sharing.svg": "098b",
	"./res-project.svg": "b9c4",
	"./res-projectmapping.svg": "d211",
	"./res-proxysetting.svg": "c8a1",
	"./res-rate.svg": "27ce",
	"./res-rds-backup.svg": "1b985",
	"./res-rds.svg": "ae65",
	"./res-recovery.svg": "71f0",
	"./res-redis.svg": "c748",
	"./res-region.svg": "6258",
	"./res-repair-order-configuration.svg": "262e",
	"./res-report-element.svg": "ce72",
	"./res-report-setting.svg": "a1d0",
	"./res-report-template.svg": "5ea8",
	"./res-report.svg": "95f2",
	"./res-resource-tag.svg": "e4ae",
	"./res-resource-type-setting.svg": "26b0",
	"./res-resourcetype.svg": "ff71",
	"./res-robot.svg": "be42",
	"./res-role.svg": "e56c",
	"./res-route-table.svg": "f013",
	"./res-routetable.svg": "d588",
	"./res-saml-provider.svg": "40fb",
	"./res-scalinggroup.svg": "86ee",
	"./res-schedpolicy.svg": "1f1d",
	"./res-schedtag.svg": "babb",
	"./res-scheduledtask.svg": "ed3f",
	"./res-secgroup.svg": "53d8",
	"./res-serverrecovery.svg": "7cc1",
	"./res-servertemplate-baremetal.svg": "ac5f",
	"./res-servertemplate-container.svg": "b51a",
	"./res-servertemplate.svg": "5c39",
	"./res-service.svg": "8449",
	"./res-servicecatalog.svg": "fc70",
	"./res-sku.svg": "44a7",
	"./res-smaluser.svg": "08eb",
	"./res-snapshotpolicy.svg": "108a",
	"./res-ssh-agent.svg": "bdb2",
	"./res-ssh-proxy.svg": "dbb3",
	"./res-ssl-certificate.svg": "f32b4",
	"./res-strategy.svg": "4e31",
	"./res-strategyallocation.svg": "bbe5",
	"./res-strategydefinition.svg": "cdfa",
	"./res-suggestsalert.svg": "e29c",
	"./res-suggestsrule.svg": "6923",
	"./res-suggestsyoverview.svg": "9462",
	"./res-suggestsysalert.svg": "3a79",
	"./res-suggestsysreport.svg": "d70e",
	"./res-suggestsysrule.svg": "c7e9c",
	"./res-suggestsysruleconfig.svg": "a77f",
	"./res-systemuser.svg": "1cbe4",
	"./res-table-storage.svg": "f40b",
	"./res-tablestore.svg": "90f5",
	"./res-tag.svg": "5f6a",
	"./res-tap-service.svg": "eb42",
	"./res-tapservice.svg": "465f",
	"./res-task.svg": "8f13",
	"./res-thirdparty.svg": "f9ab3",
	"./res-topic.svg": "cecdc",
	"./res-topology.svg": "233b",
	"./res-user.svg": "312a",
	"./res-user2.svg": "7a45",
	"./res-vm-release.svg": "065f",
	"./res-vminstance-container.svg": "d88a",
	"./res-vminstance.svg": "6402",
	"./res-vpc-network.svg": "6ccf",
	"./res-vpc-peer-connect.svg": "a269",
	"./res-vpc-peerconnect.svg": "0357",
	"./res-vpc.svg": "b3de",
	"./res-waf.svg": "2783",
	"./res-webapp.svg": "dc52",
	"./res-wire.svg": "2c5d",
	"./res-zone.svg": "46e7",
	"./resource-manage.svg": "e925",
	"./rockbase.svg": "319f",
	"./s3.svg": "8ea0",
	"./sangfor.svg": "2675",
	"./search.svg": "8e22",
	"./select-switch.svg": "d37f",
	"./setting.svg": "70ef2",
	"./smaller.svg": "1009",
	"./ssh.svg": "b128",
	"./star.svg": "881f",
	"./stared.svg": "50df",
	"./stars.svg": "8b92",
	"./start.svg": "6bba",
	"./switch.svg": "d0bc",
	"./theme-setting.svg": "645e",
	"./tls.svg": "9a55",
	"./transfer.svg": "d81ef",
	"./ucloud.svg": "aebe",
	"./uis.svg": "31f5",
	"./unstar.svg": "0dce",
	"./up.svg": "6a8e",
	"./user-del.svg": "a53a",
	"./user.svg": "c588",
	"./vmware.svg": "2d50",
	"./volcengine.svg": "cc3e",
	"./waf.svg": "73b6",
	"./webconsole.svg": "c064",
	"./workwx.svg": "d2b4",
	"./xsky.svg": "41f2",
	"./zettakit.svg": "f4c8",
	"./zizhanghao.svg": "eda8",
	"./zstack.svg": "0a57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d7c7";